import { FC } from "react";
import { iDataUser } from "../../../../interfaces/SuperAdmin/Pages/iDataUser";
import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";

interface Props {
  allUsers: iDataUser[];
  selectedUsers: string[];
  isCreating: boolean;
  setSelectedUsers: React.Dispatch<React.SetStateAction<string[]>>;
}

const UsersSection: FC<Props> = ({
  allUsers,
  selectedUsers,
  isCreating,
  setSelectedUsers,
}) => {
  // Seleccionar todos los usuarios
  const selectAllUsers = () => {
    setSelectedUsers(allUsers.map((user) => user.id_usuario));
  };

  // Función para manejar la selección/deselección de un usuario
  const toggleUser = (id: string) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((user) => user !== id) : [...prev, id]
    );
  };
  return (
    <Grid
      container
      sx={{
        p: 2,
        borderRadius: 2,
        border: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Usuarios
        </Typography>
        <Checkbox
          color="primary"
          checked={selectedUsers.length > 0}
          sx={{
            color: "#336B87",
            "&.Mui-checked": { color: "#336B87" },
          }}
          onChange={(e) => {
            if (e.target.checked) {
              selectAllUsers();
            } else {
              setSelectedUsers([]);
            }
          }}
        />
      </Grid>

      <Grid
        item
        sx={{
          marginTop: "8px",
          paddingTop: "8px",
          borderTop: "1px solid rgba(51, 107, 135, 0.5)",
          maxHeight: "350px",
          overflowY: "auto",
        }}
      >
        {allUsers.length > 0 ? (
          allUsers.map((user) => (
            <FormControlLabel
              key={user.id_usuario}
              control={
                <Checkbox
                  checked={selectedUsers.includes(user.id_usuario)}
                  disabled={isCreating}
                  onChange={() => toggleUser(user.id_usuario)}
                  sx={{
                    color: "#336B87",
                    "&.Mui-checked": { color: "#336B87" },
                  }}
                />
              }
              label={<Typography color="#000">{user.nombres}</Typography>}
              sx={{ display: "flex", alignItems: "center" }}
            />
          ))
        ) : (
          <Typography color="#73767E" fontStyle="italic" textAlign="center">
            No hay usuarios disponibles
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default UsersSection;
